/* THE BE PROJECT — révélation au scroll + chips de filtre (visuels) */
(function () {
  function init() {
    var els = document.querySelectorAll('.be .reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
      els.forEach(function (el) { io.observe(el); });
    }

    document.querySelectorAll('.be .chips').forEach(function (group) {
      if (group.dataset.beInit) return;
      group.dataset.beInit = '1';
      group.addEventListener('click', function (ev) {
        var btn = ev.target.closest('.chip');
        if (!btn) return;
        group.querySelectorAll('.chip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
